import { Button, Col, Row, Table, Tooltip, Typography } from 'antd';
import locale from 'antd/es/locale/pt_BR';

import { IUseInvestimentosTabProps } from './useInvestimentosTab';

import AlterarContaModal from './components/AlterarContaModal';
import { useInvestimentosTab } from './useInvestimentosTab';
import BotaoLimparFiltros from '../../../../../../components/BotaoLimparFiltros';
import BotaoLimparSelecao from '../../../../../../components/BotaoLimparSelecao';

const { Text } = Typography;

export const InvestimentosTab = ({
    solicitacaoId,
    orgaoId,
    isManutencao,
}: IUseInvestimentosTabProps) => {
    const {
        investimentos,
        loading,
        selectedRowKeys,
        canAlterarConta,
        isInvestimentoResgatado,
        investimentoParaAlterar,
        columns,
        rowSelection,
        refContagemDoFiltro,
        propsState,
        hasActiveFilters,
        setFilteredInfo,
        handleClearAllFilters,
        onclickTable,
        handleResetRowSelection,
        handleClickAlterarConta,
        handleCloseAlterarConta,
        handleSuccessAlterarConta,
    } = useInvestimentosTab({
        solicitacaoId,
        orgaoId,
        isManutencao,
    });

    return (
        <Col span={24}>
            <div
                style={{
                    position: 'sticky',
                    top: 84,
                    zIndex: 2,
                    width: 'fit-content'
                }}
            >
                <Row style={{ marginBottom: 4 }}>
                    <Col>
                        <Tooltip
                            title={
                                isInvestimentoResgatado
                                    ? 'Não é possível alterar a conta de um investimento resgatado'
                                    : ''
                            }
                        >
                            <span>
                                <Button
                                    type="primary"
                                    disabled={!canAlterarConta}
                                    onClick={handleClickAlterarConta}
                                    className="btn_success_vlhbegoawrgbvr"
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                >
                                    Alterar conta
                                </Button>
                            </span>
                        </Tooltip>
                    </Col>

                    <Col>
                        <BotaoLimparFiltros
                            hasActiveFilters={hasActiveFilters}
                            onClick={handleClearAllFilters}
                        />
                    </Col>

                    <Col>
                        <BotaoLimparSelecao
                            hasSelectedRows={selectedRowKeys.length > 0}
                            onClick={handleResetRowSelection}
                        />
                    </Col>
                </Row>
            </div>

            <div className="headerAbaixodosBtnTableList_ihabdfvohewvbfopu" />

            <Table
                rowKey={(record) => record.id}
                loading={loading}
                onRow={(record) => ({
                    onClick: () => onclickTable(record),
                    style: {
                        cursor: record.status === 'TOTAL_WITHDRAWAL' ? 'not-allowed' : 'pointer',
                    },
                })}
                rowSelection={rowSelection}
                style={{ marginTop: -34 }}
                columns={columns}
                dataSource={investimentos}
                scroll={{ x: 1350 }}
                onChange={(_, filters, ___, extra) => {
                    handleResetRowSelection();
                    setFilteredInfo(filters || {});
                    refContagemDoFiltro.current = extra.currentDataSource;
                }}
                title={(registros) => (
                    <div
                        style={{
                            backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                            padding: 10,
                            margin: -8,
                            marginBottom: 0.5,
                        }}
                    >
                        <Text>
                            {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                investimentos.length :
                                refContagemDoFiltro.current.length} num total de ${investimentos.length}`}
                        </Text>
                    </div>
                )}
                footer={(registros) => (
                    <div style={{ textAlign: 'end' }}>
                        <Text>
                            {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                investimentos.length :
                                refContagemDoFiltro.current.length} num total de ${investimentos.length}`}
                        </Text>
                    </div>
                )}
                size="small"
                pagination={{ locale: { items_per_page: '' } }}
                locale={locale.Table}
            />

            <AlterarContaModal
                visible={!!investimentoParaAlterar}
                investimento={investimentoParaAlterar}
                onClose={handleCloseAlterarConta}
                onSuccess={handleSuccessAlterarConta}
            />
        </Col>
    );
};

export default InvestimentosTab;
